import * as Actions from '../actions';
import moment from 'moment';

const initialState = {
    studentList: [],
    currentStudent: {
        FirstName: '',
        LastName: '',
        Email: '',
        Address: '',
        City: '',
        State: '',
        Zip: '',
        Phone: '',
        Active: 0,
        student_id: 0,
        CreateAuthID: 0,
        LastEditAuthID: 0,
        CreationDate: '',
        LastEditDate: '',
        Password: '',
        PasswordConfirm: '',
        related_auth_id: 0
    },
    editInfo: {
        CreateAuthEmail: 0,
        LastEditAuthEmail: 0,
        CreationDate: '',
        LastEditDate: '',
    },
    roles: [],
    isStudentLoaded: false,
    events: [],
    dayEvents: [],
    nextUnscheduledEvents: [],
    allCompanies: [],
    currentCompanies: [],
    dayEventsUnscheduled: [],
    courses: [],
    nextScheduledEvent: {status: 'none', event: {EventName: ''}},
    nextUnscheduledEventWidget: {status: 'none', event: {EventName: ''}},
    doesStudentHaveCourses: false,
    studentProgressReport: []
}

const studentReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.GET_STUDENT_LIST):
            {
                return {
                    ...state,
                    studentList: action.payload
                }
            }
        case (Actions.GET_STUDENT):
            {
                return {
                    ...state,
                    currentStudent: { ...initialState.currentStudent, ...action.payload }
                };
            }
        case (Actions.UPDATE_STUDENT_LOADED):
            {
                return {
                    ...state,
                    isStudentLoaded: action.payload
                }
            }
        case (Actions.GET_EDIT_INFO):
            {
                return {
                    ...state,
                    editInfo: action.payload
                }
            }
        case (Actions.DELETE_STUDENT):
            {
                return {
                    ...state,
                    currentStudent: { student_loaded: false },
                    studentList: state.studentList.filter((student) => student.student_id !== action.payload) // Removes Corresponding Student in StudentList
                };
            }

        case (Actions.UPDATE_STUDENT_FORM):
            {
                return {
                    ...state,
                    currentStudent: { ...state.currentStudent, ...action.payload }
                }
            }
        case (Actions.GET_STUDENT_SCHEDULE):
            {
                let getEventType = (course_id, module_id) => {
                    if (course_id) {
                        return 'Course'
                    }
                    else if (module_id) {
                        return 'Module'
                    }
                    return 'Lesson'
                }
                return {
                    ...state,
                    events: action.payload.map(lesson => {
                        let newDate = new Date(moment(lesson.LessonDate).format('YYYY-MM-DD HH:mm:ss'))
                        return {
                            id: lesson.company_calendar_day_id,
                            title: lesson.LessonName,
                            allDay: true,
                            start: newDate,
                            end: newDate,
                            courseName: lesson.CourseName,
                            eventType: 'full' + getEventType(lesson.company_calendar_course_id, lesson.company_calendar_module_id),
                            color: lesson.Color,
                            lesson_id: lesson.lesson_id,
                            course_id: lesson.course_id,
                            Unscheduled: lesson.Unscheduled
                        }
                    })
                }
            }
        case (Actions.GET_DAY_EVENTS):
            {   
                return {
                    ...state,
                    dayEvents: action.payload.calendar_events.map(event => {
                        return {
                            ...event,
                            allDay: false,
                            start: new Date(event.StartTime),
                            end: new Date(event.EndTime)
                        }
                    }),
                    // .concat(action.payload.todo_events.map(event => {
                    //     return {
                    //         ...event,
                    //         allDay: true,
                    //         start: new Date(event.start), 
                    //         end: new Date(event.end), 
                    //     }
                    // }))
                    
                    dayEventsUnscheduled: action.payload.todo_events.filter(e => e.Submitted != 1 && !e.attempt)
                }
            }
        case (Actions.GET_NEXT_UNSCHEDULED_EVENTS):
            {
                return {
                    ...state,
                    nextUnscheduledEvents: action.payload
                }
            }
        case (Actions.GET_RELATED_DATA):
            {
                return {
                    ...state,
                    allCompanies: action.payload.allCompanies,
                    currentCompanies: action.payload.currentCompanies,
                    currentStudent: {
                        ...state.currentStudent,
                        related_auth_id: action.payload.auth_id
                    },
                    roles: action.payload.roles
                }
            }
        case (Actions.TOGGLE_COMPANY):
            {
                if (action.payload.action_type === 'ADD') {
                    let newCompany = state.allCompanies.filter((company) => company.company_id === action.payload.company.id)
                    return {
                        ...state,
                        currentCompanies: state.currentCompanies.concat(newCompany)
                    }
                }
                else {
                    return {
                        ...state,
                        currentCompanies: state.currentCompanies.filter((company) => company.company_id !== action.payload.company.id)
                    }
                }
            }
        case (Actions.GET_STUDENT_COURSES):
            {
                return {
                    ...state,
                    courses: action.payload
                }
            }
        case (Actions.GET_NEXT_SCHEDULED_EVENT):
            {
                return {
                    ...state,
                    nextScheduledEvent: action.payload
                }
            }
        case (Actions.GET_NEXT_UNSCHEDULED_EVENT_WIDGET):
            {
                return {
                    ...state,
                    nextUnscheduledEventWidget: action.payload
                }
            }
        case (Actions.CHECK_DOES_STUDENT_HAVE_COURSES):
            {
                return {
                    ...state,
                    doesStudentHaveCourses: action.payload
                }
            }
        case (Actions.GET_STUDENT_PROGRESS_REPORT):
            {
                return {
                    ...state,
                    studentProgressReport: action.payload
                }
            }
        default:
            {
                return state;
            }
    }
}

export default studentReducer;


// WEBPACK FOOTER //
// src/main/content/student/store/reducers/student.reducer.js